export default __webpack_public_path__ + "static/media/BrainBreak cards66.cc6c1419.png";